import React from 'react'
import PropTypes from 'prop-types'

const FormContainer = (props) => {
    const { isHorizontal, children } = props
    return (
        <div className={ isHorizontal ? 'form-horizontal' : null }>
            { children }
        </div>
    )
}

FormContainer.propTypes = {
    isHorizontal: PropTypes.bool
}

FormContainer.defaultProps = {
    isHorizontal: false
}

export default FormContainer
